import * as Sentry from '@sentry/browser';
import PostHogSessionRecorder from './tracking';
var reportError = function (error) {
    Sentry.captureException(error);
};
var apiKey = process.env.POSTHOG_API_KEY;
if (window.productAnalyticsCaptureEnabled === true && apiKey) {
    new PostHogSessionRecorder(process.env.ENVIRONMENT === 'development', apiKey, reportError);
}
